module.exports = __webpack_public_path__ + "static/img/68-2.8b3d34b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/68-2.jpg
// module id = 2YoR
// module chunks = 0